<template lang="pug">
            v-dialog(v-model='dialog' persistent='' content-class="flex xs12 sm6 md6")
              v-card
                v-card-title
                  span.headline {{ formTitle }}
                v-card-text
                  v-container
                    v-row(dense)
                      v-col(cols='12' sm='12' md='12')
                        v-select(v-model='form.idProducto' label='Producto' :items='idProductoArray' outlined dense)
                    v-row(v-if="editedIndex === -1" dense)
                      v-row
                        v-col(cols='12' sm='12' md='12')
                          v-layout(align-start)
                            v-flex
                              v-data-table.elevation-1(:headers='headers' :search='search' :items='form.seriales' sort-by='numeroSerial')
                                template(v-slot:top)
                                  v-toolbar(flat color='primary' dark)
                                    v-flex(class="d-flex flex-wrap justify-center")  
                                      v-toolbar-title.head-toolbar-serialm.justify-center(color='success') Seriales
                                      v-spacer
                                      v-dialog(v-model='dialog2' persistent content-class="flex xs12 sm6 md6")
                                        // activa el boton para editar
                                        template( v-slot:activator='{ on }')
                                          v-btn.mx-2(color='success' dark v-on='on' v-if="!read" @click='dialog2 = true; focus=true' ) Agregar
                                        // activa el boton para ver
                                        //- template( v-else v-slot:activator='{ off }')
                                        v-card
                                          v-card-title
                                            span.headline {{ formTitle }}
                                          v-divider
                                          v-card-text
                                            v-container
                                              v-row(dense)
                                                v-flex(xs12)
                                                  v-text-field( autofocus dense outlined v-model='serialesObj.numeroSerial' @keyup.enter="save2" id ='numeroSerial' label='Número de Serial')
                                                VueBarcode(v-bind:value="serialesObj.numeroSerial") No existe información para mostrar

                                              v-row(dense)
                                                v-snackbar(v-model="snackbar" :color="color" top right :timeout='timeout') {{msg}}
                                                  v-btn(dark text @click="snackbar = false") Cerrar
                                          v-card-actions
                                            v-spacer
                                            v-btn(color='error' small dark @click='close2')
                                              v-icon mdi-close
                                              | Cancelar
                                            v-btn(color='success' small dark @click='save2')
                                              v-icon mdi-content-save
                                              | Guardar
                                template(v-slot:item.action='{ item }')
                                  v-icon.mr-2(color='warning' @click='editItem(item)') mdi-pencil
                                  v-icon( color='error' @click='deleteItem(item)') mdi-delete
                                template(v-slot:no-data)
                                  h2.pa-2 No hay datos de Seriales asociados
                    v-row(v-else dense) 
                      v-row(dense) 
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense outlined :readonly='read' v-model='form.numeroSerial' label='Número de Serial')
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense outlined readonly v-model='form.fechaRegistro' label='Fecha de Registro')
                      v-row(dense) 
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense outlined readonly v-model='form.idCliente' label='Cliente')
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense outlined readonly v-model='form.fechaVenta' label='Fecha de Venta')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small='' dark='' @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small='' dark='' @click='save')
                    v-icon mdi-content-save
                    | Guardar
</template>

<script>
import Api from '@/services/methods'
import VueBarcode from 'vue-barcode'
export default {
  props: ['dialog', 'FormPadre', 'editedIndex', 'read', 'serialesAlm'],
  name: 'SerialM',
  data: () => ({
    headers: [
      { text: 'Número de Serial', value: 'numeroSerial', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    dialog2: false,
    error: false,
    exito: false,
    search: '',
    focus: false,
    color: '',
    msg: '',
    snackbar: false,
    timeout: 6000,
    idProductoArray: [],
    productos: [],
    editedIndex2: -1,
    serialesObj: {
      numeroSerial: ''
    },
    defaultSeriales: {
      numeroSerial: ''
    },
    form: {
      idProducto: '',
      seriales: [],
      idCliente: '',
      numeroSerial: '',
      fechaRegistro: '',
      fechaVenta: ''
    },
    defaultForm: {
      idProducto: '',
      seriales: []
    }
  }),

  components: {
    VueBarcode
  },

  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
        if(val.idProducto) this.form.idProducto = val.idProducto._id
        if(val.idCliente) this.form.idCliente = val.idCliente.nombre
      }
    },
  },

  computed: {
    formTitle () {
      return this.editedIndex2 === -1 ? 'Nuevo Serial' : 'Modificar Serial'
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarProductos()
    },

    listarProductos () {
      Api.get('/producto')
        .then(response => {
          this.productos = response.data
          this.productos.map(data => {
            this.idProductoArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    validarCampos () {
      let serialRepetidoAlmacenado
      if (this.serialesAlm.length !== 0) {
        serialRepetidoAlmacenado = this.serialesAlm.find(serial => serial.numeroSerial === this.form.numeroSerial)
      }
      if (this.editedIndex > -1) {
        if (this.form.idProducto === '' || this.form.numeroSerial === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          return true
        }
        if (serialRepetidoAlmacenado) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto ó serial repetido',
            text: 'Por favor verifique los campos'
          })
          return true
        }
      } else {
        if (this.form.idProducto === '' || this.form.seriales.length === 0) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          return true
        }
      }
      return false
    },

    validarCampos2 () {
      let serialRepetidoPorAlmacenar, serialRepetidoAlmacenado
      if (this.form.seriales.length !== 0) {
        serialRepetidoPorAlmacenar = this.form.seriales.find(serial => serial.numeroSerial === this.serialesObj.numeroSerial)
      }
      if (this.serialesAlm.length !== 0) {
        serialRepetidoAlmacenado = this.serialesAlm.find(serial => serial.numeroSerial === this.serialesObj.numeroSerial)
      }
      if (this.serialesObj.numeroSerial === '') {
        this.color = 'error2'
        this.msg = 'Error, campo vacio ó repetido'
        this.snackbar = true
        return true
      }
      if (serialRepetidoPorAlmacenar || serialRepetidoAlmacenado) {
        this.color = 'error2'
        this.msg = 'Error, campo vacio ó repetido'
        this.snackbar = true
        return true
      }
      this.color = 'success2'
      this.msg = 'Exito, serial agregado'
      this.snackbar = true
      return false
    },

    close () {
      setTimeout(() => { this.form = Object.assign({}, this.defaultForm) }, 300)
      this.$emit('close')
    },

    close2 () {
      setTimeout(() => { this.serialesObj = Object.assign({}, this.defaultSeriales) }, 300)
      this.dialog2 = false
    },

    editItem (item) {
      this.editedIndex2 = this.form.seriales.indexOf(item)
      this.serialesObj = Object.assign({}, item)
      this.dialog2 = true
    },

    deleteItem (item) {
      const index = this.form.seriales.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.form.seriales.splice(index, 1)
        }
      })
    },

    save2 () {
      if (!this.validarCampos2()) {
        if (this.editedIndex2 > -1) {
          Object.assign(this.form.seriales[this.editedIndex2], this.serialesObj)
          this.serialesObj = Object.assign({}, this.defaultSeriales)
          this.dialog2 = false
        } else {
          this.form.seriales.push(this.serialesObj)
          this.serialesObj = Object.assign({}, this.defaultSeriales)
        }
        this.editedIndex2 = -1
      }
    },

    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('serial', this.form)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.$emit('edited', this.form)
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modifciar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        } else {
          Api.post('serial', this.form)
            .then(response => {
              this.$emit('save', this.form)
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        }
      }
    }
  }
}
</script>
<style lang="scss">
  @media screen and (max-width: 425px) {
    .head-toolbar-serialm, .head-toolbar-serialm .v-toolbar__content  {
      height: 40px !important;
    }
  }
</style>